// extracted by css-extract-rspack-plugin
export default {"DomainList":"VerifiableDomainsBanner-module__DomainList__y4nNM","ShowMore":"VerifiableDomainsBanner-module__ShowMore__jOes0"};